import * as React from 'react';
import { TouchableOpacity, FlatList, Platform, TouchableNativeFeedback, View } from 'react-native';
//import { Transition } from 'react-navigation-fluid-transitions';
import { Card, CardItem, Text, Body, Icon, Left, Right, TabHeading } from 'native-base';
import * as _ from 'lodash';
import XDate from 'xdate';

import PopupMenu from '../../components/popupMenu';

const Btn = Platform.OS === 'android' ? TouchableNativeFeedback : TouchableOpacity;

export default class LatestCustomers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	timeToString() {
		const date = new Date();
		return date.toISOString().split('T')[0];
	}
	_onPersonPress(item) {
		this.props.navigation.navigate('PersonDetails', {
			personType: 'customer',
			personId: item.id
		});
	}

	_dropSelect(item, i) {
		__DEV__ && console.log(arguments);
		if (i == 0) return this._onPersonPress(item); //view
		if (i == 1) return this.props.navigation.navigate('Entry', { addTrans: 'receipt', customer_id: item.id, addDate: this.timeToString(), paymentOnly: true }); //take payment
		if (i == 2) return this.props.navigation.navigate('Invoice', { customer_id: item.id }); //new invoice
	}

	render() {
		//get latest customers //This sort should be in reducer (customers load->re-do top. Each change bumps cust up list
		if (this.props.customers && this.props.customers.length == 0)
			return (
				<View padder>
					<Text padder>No customers yet.</Text>
					<Text>Go to the People screen to import from your phone book!</Text>
				</View>
			);

		const sorted = [...this.props.customers]
			.sort(function (a, b) {
				const alastTransaction = a.lastTransaction == '0000-00-00' ? '0001-01-01' : a.lastTransaction;
				const blastTransaction = b.lastTransaction == '0000-00-00' ? '0001-01-01' : b.lastTransaction;
				return new Date(alastTransaction) - new Date(blastTransaction);
			})
			.reverse()
			.slice(0, 30); // then reverse to get high to low
		//console.log('sorted', sorted);

		return (
			<FlatList
				style={{ marginHorizontal: 5, marginVertical: 7 }}
				horizontal
				data={sorted}
				renderItem={({ item }) => {
					return (
						<Card>
							<TouchableOpacity
								onPress={() => {
									this._onPersonPress(item);
								}}>
								<CardItem header style={{ margin: 1 }}>
									<Icon
										active
										name={item.personType == 'customer' ? 'contact' : 'cart'}
										style={{ fontSize: 28, color: (item.owes && item.owes > 0) || (item.owed && item.owed > 0) ? '#b30000' : '#29a329' }}
									/>

									<Text style={{ marginRight: 10 }}>{item.display}</Text>
									<Right style={{ position: 'absolute', right: 2, top: 2 }}>
										<PopupMenu actions={['View', 'Take Payment', 'New Invoice']} destructiveButtonIndex={null} style={{ color: '#999', padding: 10 }} onPress={(e, i) => this._dropSelect(item, i)} />
									</Right>
								</CardItem>
								<CardItem cardBody style={{ margin: 12, marginTop: 0 }}>
									<View style={{ flexDirection: 'column', flex: 1 }}>
										<View>
											<Text note style={{ textAlign: 'center' }}>
												Paid £{item.lastPaid}
												{item.lastPayable == '0.00' || ` of £${item.lastPayable}`}
											</Text>
										</View>
										<View>
											<Text note style={{ textAlign: 'center' }}>
												{`on ${XDate(item.lastTransaction).toString('dd/MM/yy')}`}
											</Text>
										</View>
									</View>
								</CardItem>
								<CardItem footer style={{ flex: 1, alignItems: 'flex-end', justifyContent: 'flex-end', margin: 1 }}>
									<View style={{ flexDirection: 'row', alignSelf: 'flex-end' }}>
										<Text>Owes </Text>
										<Text style={{ color: (item.owes && item.owes > 0) || (item.owed && item.owed > 0) ? '#b30000' : '#29a329' }}>£{item.owes}</Text>
									</View>
								</CardItem>
							</TouchableOpacity>
						</Card>
					);
				}}
				keyExtractor={(item, index) => (index ? index.toString() : null)}
			/>
		);
	}
}
